import {
	CHECK_SDP_AVAILABILITIES_SUCCESS,
	FETCH_SDP_FILTERS_SUCCESS,
	FETCH_SDP_QUOTE_REQUEST,
	FETCH_SDP_QUOTE_SUCCESS,
	SAVE_SDP_SEARCH_QUERY_STRING,
	SHOW_MORE_SDP_PRODUCTS,
	UPDATE_ACTIVE_SORT,
} from "app/pages/SmartDP/smartDPActionTypes";
import { QUOTATION_CODE_STATUS, SDP_PRODUCTS_PAGE_SIZE, SORT_TYPES } from "app/constants";
import { getDuration } from "app/utils/utils";

export const initialStaState = {
	status: "LOADING",
	accommodationsList: [],
	searchQueryString: "",
	accommodationsPageSize: SDP_PRODUCTS_PAGE_SIZE,
	destinations: [],
	departureCities: [],
	departureDateMin: undefined,
	departureDateMax: undefined,
	cabins: [],
	code: undefined,
	flights: [],
	specialOffer: undefined,
	specialOfferInfos: undefined,
	timestamp: undefined,
	sortedBy: SORT_TYPES.PRICE_ASC,
	recommendedSortActivated: undefined,
	sortUpdated: false, // used to prevent the frontend from sorting until user changes the sortedBy. Will be deprec when the flashsale products will be self-sorting (by the same criterias as the rest)
	boardTypeDescriptions: [],
};

export default (dpQuote = initialStaState, action) => {
	switch (action.type) {
		case FETCH_SDP_QUOTE_REQUEST: {
			return {
				...dpQuote,
				code: undefined,
				flights: [],
				status: "LOADING",
				specialOffer: undefined,
				specialOfferInfos: undefined,
				accommodationsList: [],
				quotationItems: [],
				accommodationsPageSize: SDP_PRODUCTS_PAGE_SIZE,
				timestamp: undefined,
				sortedBy: SORT_TYPES.PRICE_ASC,
				recommendedSortActivated: undefined,
				sortUpdated: false,
				boardTypeDescriptions: [],
			};
		}
		case SHOW_MORE_SDP_PRODUCTS:
			return {
				...dpQuote,
				accommodationsPageSize: dpQuote.accommodationsPageSize + SDP_PRODUCTS_PAGE_SIZE,
			};
		case SAVE_SDP_SEARCH_QUERY_STRING: {
			return {
				...dpQuote,
				searchQueryString: action.search,
			};
		}
		case FETCH_SDP_QUOTE_SUCCESS: {
			const data = action.res.data || {};
			const now = new Date();

			return {
				...dpQuote,
				status: data.status,
				code: data.code,
				accommodationsList: data.accommodationsList?.map(accommodation => {
					if (accommodation.endAt) {
						accommodation.expiration = getDuration(now.getTime(), accommodation.endAt);
					}

					if (accommodation.startAt) {
						accommodation.availabilityDate = getDuration(
							now.getTime(),
							accommodation.startAt
						);
					}

					return accommodation;
				}),
				flights: data.flights || [],
				quotationItems: data.quotationItems || [],
				specialOffer: data.specialOffer,
				specialOfferInfos: data.specialOfferInfos,
				timestamp: new Date().getTime(),
				sortedBy: data.defaultSort,
				recommendedSortActivated: data.recommendedSortActivated,
				boardTypeDescriptions: data.boardTypeDescriptions,
			};
		}
		case FETCH_SDP_FILTERS_SUCCESS: {
			const filters = action.res.data;
			return {
				...dpQuote,
				departureCities: filters.departureCities,
				destinations: filters.destinations,
				cabins: filters.cabins,
				departureDateMin: filters.departureDateMin,
				departureDateMax: filters.departureDateMax,
			};
		}
		case CHECK_SDP_AVAILABILITIES_SUCCESS: {
			const status = action.res.data.status;

			if (status === QUOTATION_CODE_STATUS.SESSION_EXPIRED) {
				return {
					...dpQuote,
					code: undefined,
					flights: [],
					status: "LOADING",
					specialOffer: undefined,
					specialOfferInfos: undefined,
					accommodationsList: [],
					quotationItems: [],
					accommodationsPageSize: SDP_PRODUCTS_PAGE_SIZE,
					timestamp: undefined,
					searchQueryString: "",
				};
			}
			return dpQuote;
		}
		case UPDATE_ACTIVE_SORT: {
			return {
				...dpQuote,
				sortedBy: action.activeSort,
				sortUpdated: true,
			};
		}
		default:
			return dpQuote;
	}
};
